<template>
  <div>
    <!-- <el-button style="float: right;margin-right: 5px;" icon='el-icon-plus' size='mini' type="primary" @click="handleNewRows()">新增</el-button>
    <el-button style="float: right;margin-right: 5px;" icon='el-icon-edit' size='mini' type='danger' @click="handleDelete()">删除</el-button>
    <el-button style="float: right;margin-right: 5px;" icon='el-icon-edit' size='mini' type="success" @click="handleSave()">保存</el-button> -->
    <h3>主要产品目录</h3>
    <div style="color: red"> 供应商物料分类：<span>{{mtlClass}}</span></div>
    <el-table-edit :model="dataList" ref="editTable">
      <el-table :data="dataList" size="small" style="width: 100%" @selection-change="selectionChangeHandle" :row-class-name="rowClassName" @row-dblclick="editAll">
        <el-table-column type="selection" fixed="left"></el-table-column>
        <el-table-column label="序号" header-align="center" min-width="20px" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="productName" label="产品名称" align="center" header-align="center">
          <template slot-scope="scope">
            <el-input v-if="scope.row.show" v-model="scope.row.productName" placeholder="产品名称"></el-input>
            <span v-else>{{scope.row.productName}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="supportingCompanyName" label="配套公司名称" align="center" header-align="center">
          <template slot-scope="scope">
            <el-input v-if="scope.row.show" v-model="scope.row.supportingCompanyName" placeholder="配套公司名称"></el-input>
            <span v-else>{{scope.row.supportingCompanyName}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="factoryName" label="生产工厂名称" align="center" header-align="center">
          <template slot-scope="scope">
            <el-input v-if="scope.row.show" v-model="scope.row.factoryName" placeholder="生产工厂名称"></el-input>
            <span v-else>{{scope.row.factoryName}}</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column prop="pic" label="图片地址" align="center" header-align="center">
          <template slot-scope="scope">
            <el-input v-if="scope.row.show" v-model="scope.row.pic" placeholder="图片"></el-input>
            <span v-else>{{scope.row.pic}}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="productNum" label="年配套数量(总数)" align="center" header-align="center">
          <template slot-scope="scope">
            <el-input type="number" v-if="scope.row.show" v-model="scope.row.productNum" placeholder="年配套数量(总数)"></el-input>
            <span v-else>{{scope.row.productNum}}</span>
          </template>
        </el-table-column>
        
        <!-- <el-table-column prop="venderLevel" label="供应商等级" align="center" header-align="center">
          <template slot-scope="scope">
            <el-input v-if="scope.row.show" v-model="scope.row.venderLevel" align="center" placeholder="供应商等级"></el-input>
            <span v-else>{{scope.row.venderLevel}}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="modelName" label="车型名称" align="center" header-align="center">
          <template slot-scope="scope">
            <el-input v-if="scope.row.show" v-model="scope.row.modelName" placeholder="车型名称"></el-input>
            <span v-else>{{scope.row.modelName}}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-table-edit>
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10,15,20]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>
  </div>
</template>

<script>

import {getSupplieInfo6} from '@/controller/supplier'
import Vue from 'vue'
import {getMaterialGroup} from "../../../../../controller/portal";
export default {
  computed: {
    editTable() {
      return this.$refs.editTable
    }
  },
  data () {
    return {
      show: false,
      dataList: [],
      totalPage: 0,
      pageIndex:1,
      pageSize:10,
      productName: '',
      factoryName: '',
      supportingCompanyName: '',
      pic: '',
      productNum: '',
      venderLevel: '',
      modelName: '',
      venderInviteFid: '',
      email: '',
      mtlClass:''

      // applyStatus: ''
    }
  },
  mounted() {
    this.getList()
  },
  watch: {
    venderInviteFid() {
      this.getDataList()
    }
  },
  props: {
    superId: Number
  },
  methods: {
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    handleNewRows () {
      this.dataList.push({
        edit: true,
      })
    },
    //多选
    selectionChangeHandle(val) {
      this.dataListSelections = val
    },
    rowClassName({
      row,
      rowIndex
    }) {
      row.rowid = rowIndex + 1;
    },
    editAll() {
      if(this.applyStatus != null) {
        this.dataList.map((i, index) => {
          //i.show = true
          Vue.set(this.dataList, index, i)
        })
      } else {
        this.show = false  
      }
    },
    handleSave() {
      //至少1条校验
      if (this.dataList.length <= 0) {
          this.$message.error("主要产品目录，请新增至少1条")
          return
      }
      //校验必填
      for(var i=0; i<this.dataList.length;i++){
        let msg = "序号"+(i+1);
        if(!this.dataList[i].productName){
          this.$message.error(msg+"的产品名称，不可为空")
          return
        }
        if(!this.dataList[i].supportingCompanyName){
          this.$message.error(msg+"的配套公司名称，不可为空")
          return
        }
        if(!this.dataList[i].productNum){
          this.$message.error(msg+"的年配套数量，不可为空")
          return
        }
        if(!this.dataList[i].modelName){
          this.$message.error(msg+"的车型名称，不可为空")
          return
        }
      }
      this.$refs.editTable.validate(valid => {
        // valid 为布尔值 代表表格正在编辑的所有字段是否验证通过
        if (valid) {
          const me = this
          // debugger
          // me.dataList.forEach(function (item, index) {
          //   if (me.$refs.editTable.store.getStates(item)["_states"]["editing"]) {
          //       me.editRowslist.push(item)
          //   }
          // })
          //保存方法
          this.saveData(me.dataList)
          me.editTable.cancelRows(this.dataList, false)
          me.$refs.table.clearSelection()
        }
      })
    },
    saveData(list) {
      // saveSupplierProducts({
      //   'productList' : list,
      //   'inviteId': this.venderInviteFid
      // }).then(data => {
      //   if (data && data.code === '00') {
      //     this.$message({
      //       message: '操作成功',
      //       type: 'success',
      //     })
      //     this.getDataList()
      //   } else {
      //     this.$message.error(data.msg)
      //   }
      // })
    },
    getDataList() {
      getSupplieInfo6({
        'pageNo': this.pageIndex,
        'pageSize': this.pageSize,
        'id' : this.superId
      }).then(data => {
        if (data && data.code === '00') {
          if (data.body.records.length > 0){
            this.dataList = data.body.records
            this.totalPage = data.body.total
          }
        } else {
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
      getMaterialGroup({'id' : this.superId}).then(res => {
        this.mtlClass = res.body.map((data)=>{
          return `${data.materialGroupCode}-${data.materialGroupName}`
        }).join(',')
      })
    },
    handleDelete(row) {
      // debugger
      var ids = row ? [row.rowid] : this.dataListSelections.map(item => {
        return item.rowid
      })
      var productsIds = row ? [row.productsId + ';' + row.productName] : this.dataListSelections.map(item => {
        return item.productsId + ';' + item.productName
      })
        this.$confirm(`确定对${ids.join(',')}行进行[${row ? '删除' : '删除'}]操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        console.log(productsIds)
      //   this.$http({
      //     url: this.$http.adornUrl('/venderproducts/tvenderproducts/delete'),
      //     method: 'post',
      //     data: this.$http.adornData(productsIds, false)
      //   }).then(({
      //     data
      //   }) => {
      //     if (data && data.code === 0) {
      //       this.$message({
      //         message: '删除成功',
      //         type: 'success'
      //       })
      //       this.getDataList()
      //     } else {
      //       this.$message.error(data.msg)
      //     }
      //   })
      })
    },
    getList() {
      // listInvitedForSupplier().then(data => {
      //   this.venderInviteFid = data.body.records[0].id
      // })
    },
    // 获取当前管理员信息
    getUserInfo () {
      // this.$http({
      //   url: this.$http.adornUrl('/sys/user/info'),
      //   method: 'get',
      //   params: this.$http.adornParams()
      // }).then((result) => {
      //   const data = result.data
      //   if (data && data.code === 0) {
      //     this.email = data.user.username
      //   }
      // })
    }
  }
}
</script>